import React, { useEffect, useRef, useState } from 'react';
import { SimpleTable, type SimpleTableProps } from '@interstate/components/SimpleTable';
import { useDragAndDrop } from './useDragAndDrop';

export interface DragAndDropTableProps<T> extends Partial<Omit<SimpleTableProps, 'children'>> {
    items: T[];
    onReorder: (reorderedItems: T[]) => void;
    dragHandleSelector?: string;
    animation?: number;
    children: React.ReactNode;
    'data-testid'?: string;
}

export function DragAndDropTable<T>({
    items,
    onReorder,
    dragHandleSelector,
    animation = 150,
    children,
    background = 'white',
    'data-testid': dataTestId,
    ...tableProps
}: DragAndDropTableProps<T>) {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [tbody, setTbody] = useState<HTMLElement | null>(null);

    useEffect(() => {
        // NOTE: disabling the coverage for this line beucase current?.querySelector is impossible to test outside
        // istanbul ignore next
        const element = wrapperRef.current?.querySelector('table')?.querySelector('tbody') ?? null;
        setTbody(element);
    }, []);

    useDragAndDrop({
        items,
        onReorder,
        element: tbody,
        animation,
        dragHandleSelector
    });

    return (
        <div ref={wrapperRef}>
            <SimpleTable data-testid={dataTestId} background={background} {...tableProps}>
                {children}
            </SimpleTable>
        </div>
    );
}
